<template>
  <div class="app">
    <AppHeader fixed>
      <b-link class="navbar-brand" to="#">
        <img
          class="navbar-brand-full"
          src="img/brand/logo.svg"
          width="89"
          height="25"
          alt="Gt Alarm"
        >
      </b-link>
    </AppHeader>

    <main class="main">
      <div style="padding: 0 4px;">
        <router-view></router-view>
      </div>
    </main>

    <TheFooter fixed>
      <!--footer-->
      <div>
        <a href="https://www.gtalarm.it" target="_blank">GT Alarm</a>
        <span class="ml-1">&copy; 2018</span>
      </div>
      <div class="ml-auto">
        <span class="mr-1"></span>
      </div>
    </TheFooter>
  </div>
</template>

<script>

import {
  Header as AppHeader,
  Footer as TheFooter
} from "@coreui/vue";

export default {
  name: "DefaultContainerPublic",
  components: {
    AppHeader,
    TheFooter
  },
  created() {

  },
  beforeDestroy() {

  },
  data() {
    return {

    };
  },
  methods: {

  }
};
</script>
